import {
    CalculatorsConfig,
    GenieMemoryItem,
    GenieMemoryConfig,
    GeniePadElementsSettingItem,
    GeniePtColumns,
    GenieSettings,
    MedicalHistoryConfig,
    MedicalHistorySection,
} from './api/pushGenie';
import { PrintConfig, Translate } from './api/pushVisit';
import { MDBVitalsType, SERVER_VITALS } from './components/prescriptionPad/leftPanel/vitals';
import {
    CALCULATORS_NAMES,
    CALCULATOR_RESULTS_NAME,
    CALCULATOR_VIEW,
    GROWTH_CHART_NAME,
} from './components/prescriptionPad/rightPanel/workspace/calculatorsTypes';
import { MEDICAL_HISTORY_CATEGORY } from './store/types/medicalHistory';
import { toTitleCase } from './store/utils';
import { DFormEntity } from './api/fetchDoctorGenieByOID';
import { SectionNameConfig } from './store/db';
import { INJECTION_COLUMN, LAB_TESTS_COLUMN } from './utils/enums';
import { rxKeyToHeadingMap } from './pages/opUtils';
import { DOC_TOOL, LOGIN } from './api/constants';
import { INIT } from './routes/paths';

export const LOCAL_ID_PREFIX = 'locale-';
export const LAB_VENDOR_PACKAGE_PREFIX = 'VP';
export const LAB_DOCTOR_PACKAGE_PREFIX = 'DP';

export const MAX_GENIE = 200;
export const MAX_G_SYMPTOMS = 500;
export const MAX_G_DIAGNOSIS = 500;
export const MAX_G_MEDICATIONS = 1500;
export const MAX_G_ADVICES = MAX_GENIE;
export const MAX_G_PRESCRIPTION_TEMPLATES = MAX_GENIE;
export const MAX_G_VITALS = MAX_GENIE;
export const MAX_G_LAB_TESTS = MAX_GENIE;
export const MAX_G_EXAMINATIONS = MAX_GENIE;
export const MAX_G_REFER = MAX_GENIE;
export const MAX_G_SERVICES = MAX_GENIE;
export const MAX_G_FOLLOWUP = 5;
export const MAX_G_DYFORM = MAX_GENIE;
export const MAX_G_DYFORM_ELEMENTS = 100;
export const MAX_G_LAB_VITALS = MAX_GENIE;
export const MAX_G_LT_TEMPLATES = MAX_GENIE;
export const MAX_G_LAB_VITALS_TEMPLATES = MAX_GENIE;
export const MAX_G_EXAMINATIONS_TEMPLATES = MAX_GENIE;
export const MAX_G_MED_TEMPLATES = MAX_GENIE;
export const MAX_G_SYM_TEMPLATES = MAX_GENIE;
export const MAX_G_DIA_TEMPLATES = MAX_GENIE;
export const MAX_INVENTORY = Number.MAX_SAFE_INTEGER;
export const MAX_SNACKING_QUESTION = Number.MAX_SAFE_INTEGER;
export const MAX_G_DENTAL_EXAMINATIONS = MAX_GENIE;
export const MAX_G_DENTAL_PROCEDURES = MAX_GENIE;
export const MAX_G_DENTAL_PAST_PROCEDURES = MAX_GENIE;
export const MAX_G_MEDICAL_RECORDS_TAGS = Number.MAX_SAFE_INTEGER;
export const MAX_G_TREATMENT_SERVICES = Number.MAX_SAFE_INTEGER;
export const MAX_G_TREATMENT_PACKAGES = Number.MAX_SAFE_INTEGER;
export const MAX_G_PROCEDURES_TEMPLATES = MAX_GENIE;
export const MAX_G_PROCEDURES = MAX_GENIE;

export const FLAVOUR = 'dw';

export const SIGN_IN = 'https://ekacare.typeform.com/to/ZvnoV0vK';
export const SIGN_IN_WITH_WORKSPACE = `${LOGIN}/workspace/sign-in/?next=${DOC_TOOL}${INIT}&product_type=emr`;

export const MAX_TAPERING_DOSE = 5;

export const calendlyLinks = {
    '166996653232988': 'https://calendly.com/shreya-gupta-2008',
    '169450199822106': 'https://calendly.com/anaswara-hari',
    '164388041710833': 'https://calendly.com/ashima-paul',
    '169745865427937': 'https://calendly.com/mohammed-rehan',
    '169745829611365': 'https://calendly.com/rajat-kulkarni',
    '169683540347571': 'https://calendly.com/sapan-mittal',
};

export const abhaYoutubeVidoes = [
    {
        id: 'EIQncKSeObw',
        title: 'Add patients with ABHA',
    },
    {
        id: 'I7GVC2XUxVI',
        title: 'Link records with ABHA',
    },
];

export const csColors = {
    PLUS: {
        background: 'bg-plus-csm',
        innerBg: 'bg-darwin-accent-bright-blue-100',
        innerText: 'text-darwin-neutral_new-1000',
        cta: {
            'schedule-call': {
                bg: 'bg-darwin-accent-bright-blue-800',
                text: 'text-white',
                border: '',
            },
            'chat-now': {
                bg: 'bg-white',
                text: 'text-darwin-accent-bright-blue-800',
                border: 'border-darwin-accent-bright-blue-800',
            },
        },
    },
    PRO: {
        background: 'bg-pro-csm',
        innerBg: 'bg-darwin-neutral_new-800',
        innerText: 'text-white',
        cta: {
            'schedule-call': {
                bg: 'bg-white',
                text: 'text-darwin-neutral_new-1000',
                border: '',
            },
            'chat-now': {
                bg: 'bg-transparent',
                text: 'text-white',
                border: 'border-white',
            },
        },
    },
};

export const DYNAMIC_FORMS: DFormEntity[] = [
    {
        label: 'Salutation',
        type: 'string',
        key: 'salutation',
    },
    {
        label: 'Patient Address',
        type: 'string',
        key: 'paddress',
    },
    {
        label: 'City',
        type: 'string',
        key: 'city',
    },
    {
        label: 'Pincode',
        type: 'string',
        key: 'pincode',
    },
    {
        label: 'Mail ID',
        type: 'string',
        key: 'email',
    },
    {
        label: 'Blood Group',
        type: 'string',
        key: 'bloodgroup',
    },
    {
        label: 'Alternative Phone',
        type: 'string',
        key: 'aphone',
    },
    {
        label: 'Referred By Doctor',
        type: 'string',
        key: 'referredby',
    },
    {
        label: "Referred Doctor's Number",
        type: 'number',
        key: 'referredbynumber',
    },
    {
        label: 'Marital Status',
        type: 'string',
        key: 'maritalstatus',
    },
    {
        label: 'Name of Informant',
        type: 'string',
        key: 'noi',
    },
    {
        label: 'Channel',
        type: 'string',
        key: 'channel',
    },
    {
        label: "Patient's Occupation",
        type: 'string',
        key: 'pocc',
    },
    {
        label: 'Tag',
        type: 'string',
        key: 'tag',
    },
    {
        label: 'Guardian Name',
        type: 'string',
        key: 'gnn',
    },
    {
        label: 'Relationship with patient',
        type: 'string',
        key: 'rpp',
    },
    {
        label: 'Phone country code',
        type: 'string',
        key: 'pcc',
    },
    {
        label: 'Patient Language',
        type: 'string',
        key: 'lang',
    },
];

const DYNAMIC_FORMS_WITH_UHID = [
    {
        label: 'UHID',
        type: 'string',
        key: 'uhid',
    },
    ...DYNAMIC_FORMS,
];

export const MEDICAL_HISTORY_SECTIONS_OPTION: MedicalHistorySection[] = [
    {
        label: 'Existing Conditions',
        type: 'string',
        key: MEDICAL_HISTORY_CATEGORY.PATIENT_MEDICAL_CONDITIONS,
    },
    {
        label: 'Family History',
        type: 'string',
        key: MEDICAL_HISTORY_CATEGORY.FAMILY_HISTORY,
    },
    {
        label: 'LifeStyle Habit',
        type: 'string',
        key: MEDICAL_HISTORY_CATEGORY.LIFESTYLE_HABITS,
    },
    {
        label: 'Food/Other Allergy',
        type: 'string',
        key: MEDICAL_HISTORY_CATEGORY.FOOD_OTHER_ALLERGY,
    },
    {
        label: 'Drug Allergy',
        type: 'string',
        key: MEDICAL_HISTORY_CATEGORY.DRUG_ALLERGY,
    },
    {
        label: 'Past Surgical Procedures',
        type: 'string',
        key: MEDICAL_HISTORY_CATEGORY.PAST_PROCEDURES,
    },
    {
        label: 'Current Medications',
        type: 'string',
        key: MEDICAL_HISTORY_CATEGORY.CURRENT_MEDICATIONS,
    },
    {
        label: 'Travel History',
        type: 'string',
        key: MEDICAL_HISTORY_CATEGORY.RECENT_TRAVEL_HISTORY,
    },
    {
        label: 'Other medical history',
        type: 'string',
        key: MEDICAL_HISTORY_CATEGORY.OTHER_MEDICAL_HISTORY,
    },
];

const patientFormAllKeys = DYNAMIC_FORMS_WITH_UHID?.reduce((preForm, curForm) => {
    return { ...preForm, [curForm.key]: true };
}, {});

const patientFormKeyNameMapping = DYNAMIC_FORMS_WITH_UHID?.reduce((preForm, curForm) => {
    if (curForm.key === 'salutation') {
        return preForm;
    }
    return { ...preForm, [curForm.key]: curForm.label };
}, {});

const patientHistoryAllKeys = MEDICAL_HISTORY_SECTIONS_OPTION?.reduce((preMH, curMH) => {
    return { ...preMH, [curMH.key]: true };
}, {});

const medicalHistoryAllKeys: GeniePadElementsSettingItem[] = [
    { id: 'dose', name: 'Print Dose', isShown: true },
    { id: 'duration', name: 'Print Duration', isShown: true },
    { id: 'instruction', name: 'Print Instruction', isShown: true },
    { id: 'quantity', name: 'Print Quantity', isShown: true },
    { id: 'frequency', name: 'Print Frequency', isShown: true },
    { id: 'doseFrequency', name: 'Print Dose Frequency', isShown: false },
];
const medicationKeys = medicalHistoryAllKeys.reduce((acc, item) => {
    acc[item.id] = item.isShown;
    return acc;
}, {} as { [key: string]: boolean });
const medicationKeyToLabel = medicalHistoryAllKeys.reduce((acc, item) => {
    acc[`${item.id}`] = item.name;
    return acc;
}, {} as { [key: string]: string });
const patientHistoryKeyNameMapping = MEDICAL_HISTORY_SECTIONS_OPTION?.reduce((preMH, curMH) => {
    return { ...preMH, [curMH.key]: curMH.label };
}, {});

// Keys are pumped into it on Px load
export const PRINT_CONFIGS_KEYS_TO_LABEL: { [k: string]: string } = {
    examinations: 'Examinations',
    diagnosis: 'Diagnosis',
    symptoms: 'Symptoms',
    vitals: 'Vitals',
    medications: 'Medications',
    injections: 'Injections',
    labTests: 'Lab Tests',
    followup: 'Followup',
    advices: 'Advices',
    patientMedicalHistory: 'Patient Medical History',
    prescriptionNotes: 'Notes for Patient',
    dyform: 'Custom Section',
    labVitals: 'Lab Results',
    patientForm: 'Patient Form',
    age: 'Age',
    phone: 'Mobile Number',
    gender: 'Gender',
    properties: 'Properties',
    // for lab vitals sub properties
    isOutOfRange: 'Out of Range Values Only',
    // for medication
    genericName: 'Generic Name',
    showPropertiesValueOnly: 'Hide Property Headers',
    showICD: 'Show ICD',
    hideName: 'Exclude Name if ICD is present',
    hideBrandName: 'Hide Brand Name',
    productType: 'Product Type',
    ...medicationKeyToLabel,
    doseFrequency: 'Replace Frequency to Dose Frequency',
    // for lab investigation
    showLabTestsIncludedInPackage: 'Show Lab Tests Included In Package',
    // for patient form sub properties
    ...patientFormKeyNameMapping,

    // medical history
    ...patientHistoryKeyNameMapping,
    dentalExaminations: 'Dental Examinations / Past Procedures',
    dentalProcedures: 'Dental Procedures',
    growthChart: 'Growth Chart',
    heightForAge: GROWTH_CHART_NAME.HEIGHT_FOR_AGE,
    weightForAge: GROWTH_CHART_NAME.WEIGHT_FOR_AGE,
    weightForHeight: GROWTH_CHART_NAME.WEIGHT_FOR_HEIGHT,
    ofcForAge: GROWTH_CHART_NAME.OFC_FOR_AGE,
    bmiForAge: GROWTH_CHART_NAME.BMI_FOR_AGE,
    ...rxKeyToHeadingMap,
    additionalNotes: 'Additional Notes',
    conductedBy: 'Conducted By',
    assistedBy: 'Assisted By',
    procedures: 'Procedures',
    careCanvas: 'Canvas',
    taperingDoseTitleDisplay: 'Tapering Dose show title',
};

export enum PAD_CONFIG_KEYS {
    MEDICAL_HISTORY_CONFIG = 'medicalHistoryPadConfig',
    ELEMENT_PAD_CONFIG = 'elementPadConfig',
    VITALS_PAD_CONFIG = 'vitalsPadConfig',
}

export const DEFAULT_PRINT_CONFIG: PrintConfig = {
    examinations: true,
    diagnosis: {
        entity: true,
        properties: true,
        showPropertiesValueOnly: false,
    },
    symptoms: {
        entity: true,
        properties: true,
        showPropertiesValueOnly: false,
    },
    medications: {
        entity: true,
        genericName: true,
        productType: true,
        // this brandName key is unused
        brandName: true,
        hideBrandName: false,
        taperingDoseTitleDisplay: false,
        doseFrequency: false,
        ...medicationKeys,
    },
    injections: {
        entity: true,
        genericName: true,
        brandName: true,
        hideBrandName: false,
    },
    labTests: {
        entity: true,
        properties: true,
        showLabTestsIncludedInPackage: false,
    },
    labVitals: {
        entity: true,
        isOutOfRange: false,
    },
    followup: true,
    advices: true,
    vitals: true,
    patientMedicalHistory: {
        entity: true,
        properties: true,
        showPropertiesValueOnly: false,
        ...patientHistoryAllKeys,
    },
    prescriptionNotes: true,
    dyform: {},
    patientForm: {
        entity: true,
        age: true,
        phone: true,
        gender: true,
        ...patientFormAllKeys,
    },
    dentalExaminations: true,
    dentalProcedures: {
        entity: true,
        additionalNotes: true,
        conductedBy: true,
        assistedBy: true,
    },
    growthChart: {
        entity: true,
        heightForAge: true,
        weightForAge: true,
        weightForHeight: true,
        ofcForAge: true,
        bmiForAge: true,
    },
    opVision: {
        entity: true,
    },
    opIop: {
        entity: true,
    },
    opCurrentSpec: {
        entity: true,
    },
    opSubjectiveRefraction: {
        entity: true,
    },
    opAutoRefraction: {
        entity: true,
    },
    opFinalPrescription: {
        entity: true,
    },
    procedures: {
        entity: true,
    },
    careCanvas: {
        entity: true,
    },
};

export const PT_DETAILS = 'patient_details';
export const CONTACT = 'contact';
export const LAST_VISITED = 'last_visited';
export const FOLLOW_UP = 'follow_up';
export const UHID = 'uhid';
export const ABHA_IDS = 'abha_ids';

export const DEFAULT_PT_COLUMNS: GeniePtColumns = [
    PT_DETAILS,
    CONTACT,
    UHID,
    LAST_VISITED,
    FOLLOW_UP,
    ABHA_IDS,
];
export const MANDATE_PT_COLUMNS = [PT_DETAILS, UHID, CONTACT];

const PT_LABEL: { [k: string]: string } = {
    [PT_DETAILS]: 'Patient Details',
    [CONTACT]: 'Contact',
    [UHID]: 'UHID',
    [LAST_VISITED]: 'Last Visited',
    [FOLLOW_UP]: 'Follow Up',
    [ABHA_IDS]: 'ABHA Id',
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// export const VITALS: MDBVitalsType[] = window.__vitals__ || SERVER_VITALS;
export const VITALS: MDBVitalsType[] = SERVER_VITALS;

export const keyToLabel = (k: string): string => PT_LABEL[k] || toTitleCase(k.replace('_', ' '));

export const PAD_CONFIG_FOLLOW_UP_ADVICES_ID = 'followup-advices';
export const DENTAL_CHART = 'dentalChart';
const DENTAL_EXAMINATIONS = 'dentalExaminations';
const DENTAL_PROCEDURES = 'dentalProcedures';
export const DENTAL_KEYS = new Set([DENTAL_EXAMINATIONS, DENTAL_PROCEDURES]);
export const FOLLOW_UP_ADVICES_PAD_CONFIG = {
    id: PAD_CONFIG_FOLLOW_UP_ADVICES_ID,
    name: 'Follow Up & Advices',
    isShown: true,
};
export const PAD_CONFIG_VITALS_CONFIG = { id: 'vitals', name: 'Vitals', isShown: true };
export const DEFAULT_PAD_CONFIG: GeniePadElementsSettingItem[] = [
    PAD_CONFIG_VITALS_CONFIG,
    { id: 'medicalHistory', name: 'Patient Medical History', isShown: true },
    { id: 'symptoms', name: 'Symptoms', isShown: true },
    { id: 'diagnosis', name: 'Diagnosis', isShown: true },
    { id: 'medications', name: 'Medications', isShown: true },
    { id: 'injections', name: 'Injections', isShown: false },
    { id: 'labTests', name: 'Investigations', isShown: true },
    { id: 'labVitals', name: 'Lab Results', isShown: true },
    { id: 'examinations', name: 'Examination Findings', isShown: true },
    { id: 'prescriptionNotes', name: 'Notes', isShown: true },
    { id: 'refer', name: 'Refer a doctor', isShown: true },
    { id: 'dentalChart', name: 'Dental Chart', isShown: false },
    { id: 'opVision', name: 'Ophthalmology - Visual Acuity Test', isShown: false },
    { id: 'opSubjectiveRefraction', name: 'Ophthalmology - Subjective Refraction', isShown: false },
    { id: 'opAutoRefraction', name: 'Ophthalmology - Auto Refraction', isShown: false },
    { id: 'opCurrentSpec', name: 'Ophthalmology - Current Glass Prescription', isShown: false },
    { id: 'opFinalPrescription', name: 'Ophthalmology - Final Glass Prescription', isShown: false },
    { id: 'opIop', name: 'Ophthalmology - IOP', isShown: false },
    FOLLOW_UP_ADVICES_PAD_CONFIG,
    { id: 'procedures', name: 'Procedures', isShown: true },
];

export const MED_TABLE_COL_DOSE_KEY = 'dose';
export const MED_TABLE_COL_FREQUENCY_KEY = 'frequency';
export const MED_TABLE_COL_TIMING_KEY = 'timing';
export const MED_TABLE_COL_DURATION_KEY = 'duration';
export const MED_TABLE_COL_START_FROM_KEY = 'start_from';
export const MED_TABLE_COL_INSTRUCTION_KEY = 'instruction';
export const MED_TABLE_COL_QUANTITY_KEY = 'quantity';

export const DEFAULT_MEDICATIONS_TABLE_CONFIG: GeniePadElementsSettingItem[] = [
    { id: MED_TABLE_COL_DOSE_KEY, name: 'Dose', isShown: true },
    { id: MED_TABLE_COL_FREQUENCY_KEY, name: 'Frequency', isShown: true },
    { id: MED_TABLE_COL_TIMING_KEY, name: 'Timing', isShown: true },
    { id: MED_TABLE_COL_DURATION_KEY, name: 'Duration', isShown: true },
    { id: MED_TABLE_COL_START_FROM_KEY, name: 'Start From', isShown: true },
    { id: MED_TABLE_COL_INSTRUCTION_KEY, name: 'Instruction', isShown: true },
    { id: MED_TABLE_COL_QUANTITY_KEY, name: 'Quantity', isShown: false },
];

export const DEFAULT_INJECTIONS_TABLE_CONFIG: GeniePadElementsSettingItem[] = [
    { id: INJECTION_COLUMN.DOSE, name: 'Dose', isShown: true },
    { id: INJECTION_COLUMN.ROUTE, name: 'Route', isShown: true },
    { id: INJECTION_COLUMN.INFUSION_RATE, name: 'Infusion Rate', isShown: true },
    { id: INJECTION_COLUMN.FREQUENCY, name: 'Frequency', isShown: true },
    { id: INJECTION_COLUMN.DURATION, name: 'Duration', isShown: true },
    { id: INJECTION_COLUMN.TIMING, name: 'Timing', isShown: true },
    { id: INJECTION_COLUMN.INSTRUCTIONS, name: 'Instructions', isShown: true },
];

const KEYS_TO_EXCLUDE_FROM_MED_GENIE = [MED_TABLE_COL_START_FROM_KEY, MED_TABLE_COL_QUANTITY_KEY];

export const DEFAULT_GENIE_MEDICATIONS_TABLE_CONFIG = DEFAULT_MEDICATIONS_TABLE_CONFIG.filter(
    (config) => !KEYS_TO_EXCLUDE_FROM_MED_GENIE.find((key) => key === config.id),
);

export const DEFAULT_PAD_CONFIG_KEY_SET = new Set(DEFAULT_PAD_CONFIG.map((c) => c.id));

interface Calculator {
    name: CALCULATORS_NAMES;
    title: string;
    api: string;
    result: {
        id: string;
        name: CALCULATOR_RESULTS_NAME;
        type: 'DEFAULT' | 'DATE';
    };
    view: CALCULATOR_VIEW;
    isNewView?: boolean;
}

export const CALCULATORS: Calculator[] = [
    {
        name: CALCULATORS_NAMES.HOMA_IR,
        title: 'HOMA-IR',
        api: '/homa-ir.json',
        result: {
            id: 'lb-7193475414',
            name: CALCULATOR_RESULTS_NAME.HOMA_IR,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.WAIST_HIP_RATIO,
        title: 'Waist-hip ratio',
        api: '/waist-hip-ratio.json',
        result: {
            id: 'lb-7317352025',
            name: CALCULATOR_RESULTS_NAME.WAIST_HIP_RATIO,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.QUICKI,
        title: 'QUICKI',
        api: '/quicki.json',
        result: {
            id: 'lb-8439921850',
            name: CALCULATOR_RESULTS_NAME.QUICKI,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.CHILD_PUGH,
        title: 'Child Pugh',
        api: '/child-pugh.json',
        result: {
            id: 'lb-7087586733',
            name: CALCULATOR_RESULTS_NAME.CHILD_PUGH,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.MELD,
        title: 'MELD',
        api: '/meld.json',
        result: {
            id: 'lb-1054468702',
            name: CALCULATOR_RESULTS_NAME.MELD,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.GFR,
        title: 'eGFR (CKD-EPI 2021)',
        api: '/gfr.json',
        result: {
            id: 'lb-5849080835',
            name: CALCULATOR_RESULTS_NAME.GFR,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.NAFLD,
        title: 'NAFLD Fibrosis Score',
        api: '/nafld.json',
        result: {
            id: 'lb-5366328051',
            name: CALCULATOR_RESULTS_NAME.NAFLD,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.ESS,
        title: 'Epworth Sleepiness Scale',
        api: '/ess.json',
        result: {
            id: 'lb-1278401406',
            name: CALCULATOR_RESULTS_NAME.ESS,

            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.ABCD_TIA,
        title: 'ABCD² Score for TIA',
        api: '/abcd-2-calculator.json',
        result: {
            id: 'lb-8692519119',
            name: CALCULATOR_RESULTS_NAME.ABCD_TIA,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.LMP_EDD,
        title: 'LMP EDD',
        api: '/lmp-edd.json',
        result: {
            id: 'lb-124489990',
            name: CALCULATOR_RESULTS_NAME.LMP_EDD,
            type: 'DATE',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.US_EDD,
        title: 'USG EDD',
        api: '/us-edd.json',
        result: {
            id: 'lb-6638011898',
            name: CALCULATOR_RESULTS_NAME.US_EDD,
            type: 'DATE',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.CVD_RISK,
        title: 'Cardiovascular Disease 10-year Risk',
        api: '/cvd-risk.json',
        result: {
            id: 'lb-939394523',
            name: CALCULATOR_RESULTS_NAME.CVD_RISK,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.HAS_BLED,
        title: 'HAS-BLED Calculator',
        api: '/has-bled.json',
        result: {
            id: 'lb-4465487183',
            name: CALCULATOR_RESULTS_NAME.HAS_BLED,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.CHA2DS2_VASC,
        title: 'CHA2DS2-Vasc Calculator',
        api: '/cha2ds2-vasc.json',
        result: {
            id: 'lb-1419307595',
            name: CALCULATOR_RESULTS_NAME.CHA2DS2_VASC,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.RCRI,
        title: 'RCRI Calculator',
        api: '/rcri.json',
        result: {
            id: 'lb-1059798171',
            name: CALCULATOR_RESULTS_NAME.RCRI,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.VITAL_CAPACITY,
        title: 'Vital Capacity',
        api: '/vital-capacity.json',
        result: {
            id: 'lb-9661221232',
            name: CALCULATOR_RESULTS_NAME.VITAL_CAPACITY,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.BODE_INDEX,
        title: 'Bode Index',
        api: '/bode-index.json',
        result: {
            id: 'lb-3435143911',
            name: CALCULATOR_RESULTS_NAME.BODE_INDEX,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.FIB_4,
        title: 'FIB-4',
        api: '/fib-4.json',
        result: {
            id: 'lb-2679064069',
            name: CALCULATOR_RESULTS_NAME.FIB_4,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.IV_FLOW_RATE,
        title: 'IV Flow Rate',
        api: '/iv-flow-rate.json',
        result: {
            id: 'lb-2679064012',
            name: CALCULATOR_RESULTS_NAME.IV_FLOW_RATE,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.INJECTIONS,
    },
    {
        name: CALCULATORS_NAMES.PEDIATRIC_DOSE,
        title: 'Pediatric Dose',
        api: '/pediatric-dose.json',
        result: {
            id: 'du-2334657215',
            name: CALCULATOR_RESULTS_NAME.PEDIATRIC_DOSE,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.MEDICATIONS,
    },
    {
        name: CALCULATORS_NAMES.COPD_CAT,
        title: 'COPD - CAT',
        api: '/copd-cat.json',
        result: {
            id: 'lb-5799518634',
            name: CALCULATOR_RESULTS_NAME.COPD_CAT,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
        isNewView: true,
    },
    {
        name: CALCULATORS_NAMES.CCI,
        title: 'Charlson Comorbidity Index (CCI)',
        api: '/cci.json',
        result: {
            id: 'lb-8133190909',
            name: CALCULATOR_RESULTS_NAME.CCI,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
        isNewView: true,
    },
    {
        name: CALCULATORS_NAMES.REVEAL_TEST,
        title: 'REVEAL Test',
        api: '/reveal-test.json',
        result: {
            id: 'lb-1519166844',
            name: CALCULATOR_RESULTS_NAME.REVEAL_TEST,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
        isNewView: true,
    },
    {
        name: CALCULATORS_NAMES.IPSS,
        title: 'International Prostate Symptom Score (IPSS)',
        api: '/ipss.json',
        result: {
            id: 'lb-2828792723',
            name: CALCULATOR_RESULTS_NAME.IPSS,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
        isNewView: true,
    },
    {
        name: CALCULATORS_NAMES.CRCL,
        title: 'Creatinine Clearance (CrCl)',
        api: '/crcl.json',
        result: {
            id: 'lb-9106943834',
            name: CALCULATOR_RESULTS_NAME.CRCL,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.PGE2,
        title: 'Progesterone to Estrogen Ratio',
        api: '/pge2.json',
        result: {
            id: 'lb-3235419275',
            name: CALCULATOR_RESULTS_NAME.PGE2,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.GESTATIONAL_AGE,
        title: 'Gestational Age',
        api: '/gestational-age.json',
        result: {
            id: 'lb-4630182613',
            name: CALCULATOR_RESULTS_NAME.GESTATIONAL_AGE,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
        isNewView: true,
    },
    {
        name: CALCULATORS_NAMES.DASI,
        title: 'Duke Activity Status Index',
        api: '/dasi.json',
        result: {
            id: 'lb-1002371297',
            name: CALCULATOR_RESULTS_NAME.DASI,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.GCS,
        title: 'Glasgow Coma Scale',
        api: '/gcs.json',
        result: {
            id: 'lb-7607896617',
            name: CALCULATOR_RESULTS_NAME.GCS,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
    {
        name: CALCULATORS_NAMES.STOP_BANG,
        title: 'Stop Bang',
        api: '/stop-bang.json',
        result: {
            id: 'lb-4603437732',
            name: CALCULATOR_RESULTS_NAME.STOP_BANG,
            type: 'DEFAULT',
        },
        view: CALCULATOR_VIEW.VITALS,
    },
];

export const CALC_NAME_TO_ID = CALCULATORS.filter((i) => i.view === CALCULATOR_VIEW.VITALS).reduce(
    (acc, cur) => {
        acc[cur.name] = cur.result.id;
        return acc;
    },
    {} as { [key: string]: string },
);

export enum MESSAGE_CONFIG_ID {
    RX_DELAYED_WHATSAPP_MESSAGE = 'rx_delayed_whatsapp_message',
}

const MESSAGE_CONFIG = [
    {
        id: MESSAGE_CONFIG_ID.RX_DELAYED_WHATSAPP_MESSAGE,
        title: 'Send Prescription On Visit End',
        summary:
            'Prescription Communication will be sent only on visit end.\n(By Default : Rx is sent as soon as its created)',
        status: false,
    },
];

export const DEFAULT_MEDICATIONS_MEMORY_CONFIG: GenieMemoryItem[] = [
    { id: MED_TABLE_COL_DOSE_KEY, remember: true },
    { id: MED_TABLE_COL_FREQUENCY_KEY, remember: true },
    { id: MED_TABLE_COL_TIMING_KEY, remember: true },
    { id: MED_TABLE_COL_DURATION_KEY, remember: true },
    { id: MED_TABLE_COL_START_FROM_KEY, remember: true },
    { id: MED_TABLE_COL_INSTRUCTION_KEY, remember: true },
];

export const DEFAULT_INJECTIONS_MEMORY_CONFIG: GenieMemoryItem[] = [
    { id: INJECTION_COLUMN.DOSE, remember: true },
    { id: INJECTION_COLUMN.ROUTE, remember: true },
    { id: INJECTION_COLUMN.INFUSION_RATE, remember: true },
    { id: INJECTION_COLUMN.FREQUENCY, remember: true },
    { id: INJECTION_COLUMN.DURATION, remember: true },
    { id: INJECTION_COLUMN.TIMING, remember: true },
    { id: INJECTION_COLUMN.INSTRUCTIONS, remember: true },
];

export const DEFAULT_LAB_TESTS_MEMORY_CONFIG: GenieMemoryItem[] = [
    { id: LAB_TESTS_COLUMN.REMARK, remember: true },
];

export const MEDICATIONS_MEMORY_NAMES = {
    [MED_TABLE_COL_DOSE_KEY]: 'Dose',
    [MED_TABLE_COL_FREQUENCY_KEY]: 'Frequency',
    [MED_TABLE_COL_TIMING_KEY]: 'Timing',
    [MED_TABLE_COL_DURATION_KEY]: 'Duration',
    [MED_TABLE_COL_START_FROM_KEY]: 'Start From',
    [MED_TABLE_COL_INSTRUCTION_KEY]: 'Instruction',
};

export const INJECTIONS_MEMORY_NAMES = {
    [INJECTION_COLUMN.DOSE]: 'Dose',
    [INJECTION_COLUMN.ROUTE]: 'Route',
    [INJECTION_COLUMN.INFUSION_RATE]: 'Infusion Rate',
    [INJECTION_COLUMN.FREQUENCY]: 'Frequency',
    [INJECTION_COLUMN.DURATION]: 'Duration',
    [INJECTION_COLUMN.TIMING]: 'Timing',
    [INJECTION_COLUMN.INSTRUCTIONS]: 'Instructions',
};

export const LAB_TESTS_MEMORY_NAMES = {
    [LAB_TESTS_COLUMN.REMARK]: 'Remark',
};

export const DEFAULT_GENIE_MEMORY_CONFIG: GenieMemoryConfig = {
    medications: DEFAULT_MEDICATIONS_MEMORY_CONFIG,
    injections: DEFAULT_INJECTIONS_MEMORY_CONFIG,
    labTests: DEFAULT_LAB_TESTS_MEMORY_CONFIG,
    isInjectionsEnabled: true,
    isMedicationsEnabled: true,
    isLabTestEnabled: true,
};

export const DEFAULT_GENIE_SETTINGS: GenieSettings = {
    betaSchedule: false,
    openPrintPdfInNewTab: false,
    sendWelcome: true,
    dform: false,
    smartSuggestions: true,
    showVaccinationChart: false,
    padElements: DEFAULT_PAD_CONFIG,
    medElements: DEFAULT_MEDICATIONS_TABLE_CONFIG,
    injectionTableConfig: DEFAULT_INJECTIONS_TABLE_CONFIG,
    autoFillFollowUp: true,
    barcodeEnabled: false,
    isHEDeactivated: false,
    hxngPreferredLabPartnerId: [],
    twinHealthEnabled: false,
    isHealthWeekDoctor: false,
    abdm: false,
    propertiesFocusSkip: false,
    medTypeIds: [],
    messageConfig: MESSAGE_CONFIG,
    showMedicalHistoryInAddPt: true,
    anf: true,
    hideNewHxngFlow: false,
    icdSuggestion: false,
    growthChart: false,
    isSendAbhaOtp: false,
    isHxngPatientConsent: false,
    hidePatientHealthSummary: false,
    showMilestone: false,
    disableAutoScrollOnSelect: false,
    meetDocAssistDisabled: false,
    medsCopilot: false,
    saEnabled: false,
    isDoseCalculatorAvailable: false,
    bizLevelPt: false,
    admissionToIPDEnabled: false,
    showVoiceToRxPopover: true,
    genieMemoryConfig: DEFAULT_GENIE_MEMORY_CONFIG,
    medRouteEnabled: false,
};

export const DEFAULT_VITALS_CONFIG_VALUES = {
    selectedItems: VITALS.map((ele) => ({
        id: ele.id,
        name: ele.name,
    })),
};

export const DEFAULT_CALCULATOR_CONFIG_VALUES: CalculatorsConfig = {
    selectedItems: CALCULATORS.filter((i) => i.view === CALCULATOR_VIEW.VITALS).map((calc) => ({
        label: calc.title,
        type: 'string',
        key: calc.name,
        isShown: false,
    })),
};

export const GROWTH_CHART_VITALS: MDBVitalsType[] = [
    {
        id: 'lb-7991006736',
        name: 'Body weight',
        dis_name: 'Weight',
        units_with_ranges: [
            {
                dis_unit: 'Kgs',
                code: '258683005',
                code_id: 'vu-2306951588',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '0',
                    high: '300',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
            {
                dis_unit: 'Lbs',
                code: '258693003',
                code_id: 'vu-2307875107',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '0',
                    high: '500',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-7561569471',
        name: 'Body height',
        dis_name: 'Height',
        units_with_ranges: [
            {
                dis_unit: 'Cms',
                code: '258672001',
                code_id: 'vu-2305998272',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '0',
                    high: '250',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
            {
                dis_unit: 'Feet',
                code: '259051005',
                code_id: 'vu-3019850218',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '0',
                    high: '10',
                    type: 'string',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-5305097546',
        name: 'Body mass index',
        dis_name: 'BMI',
        units_with_ranges: [
            {
                dis_unit: 'kg/m2',
                code: '60621009',
                code_id: 'vu-9497159785',
                system: 'http://snomed.info/sct',
                safe: {
                    low: '18.5',
                    high: '24.9',
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-7205446246',
        name: 'Occipital Frontal Circumference (OFC)',
        dis_name: 'Occipital Frontal Circumference (OFC)',
        units_with_ranges: [
            {
                dis_unit: 'cm',
                code_id: 'lu-32969',
                code: '',
                system: 'http://snomed.info/sct',
                safe: {
                    type: 'Numeric',
                    is_decimal_allowed: true,
                },
            },
        ],
    },
    {
        id: 'lb-5257276261',
        name: 'Gestational Age',
        dis_name: 'Gestational Age',
        units_with_ranges: [
            {
                dis_unit: 'days',
                code_id: 'lu-1061',
                code: '',
                system: 'http://snomed.info/sct',
                safe: {
                    type: 'Numeric',
                    is_decimal_allowed: false,
                },
            },
        ],
    },
];

type GrowthChartResult = {
    id: string;
    name: string;
    dis_name: string;
    units_with_ranges: {
        dis_unit: string;
        code_id: string;
        safe: {
            type: string;
            is_decimal_allowed: boolean;
        };
    }[];
};

export const GROWTH_CHART_RESULTS: { [k: string]: GrowthChartResult } = {
    // Weight
    'lb-6580967293': {
        id: 'lb-6580967293',
        name: 'Weight for Age (Percentile)',
        dis_name: 'Weight for Age (Percentile)',
        units_with_ranges: [
            {
                dis_unit: 'Percentile',
                code_id: 'lu-9485148810',
                safe: {
                    type: 'Numeric',
                    is_decimal_allowed: false,
                },
            },
        ],
    },
    'lb-1297034741': {
        id: 'lb-1297034741',
        name: 'Weight for Age (Z-Score)',
        dis_name: 'Weight for Age (Z-Score)',
        units_with_ranges: [
            {
                dis_unit: 'Score',
                code_id: 'lu-8580719618',
                safe: {
                    type: 'Numeric',
                    is_decimal_allowed: false,
                },
            },
        ],
    },
    // Height
    'lb-8961902374': {
        id: 'lb-8961902374',
        name: 'Height for Age (Percentile)',
        dis_name: 'Height for Age (Percentile)',
        units_with_ranges: [
            {
                dis_unit: 'Percentile',
                code_id: 'lu-9485148810',
                safe: {
                    type: 'Numeric',
                    is_decimal_allowed: false,
                },
            },
        ],
    },
    'lb-489488198': {
        id: 'lb-489488198',
        name: 'Height for Age (Z-Score)',
        dis_name: 'Height for Age (Z-Score)',
        units_with_ranges: [
            {
                dis_unit: 'Score',
                code_id: 'lu-8580719618',
                safe: {
                    type: 'Numeric',
                    is_decimal_allowed: false,
                },
            },
        ],
    },
    // Weight for Height
    'lb-953907228': {
        id: 'lb-953907228',
        name: 'Weight for Height (Percentile)',
        dis_name: 'Weight for Height (Percentile)',
        units_with_ranges: [
            {
                dis_unit: 'Percentile',
                code_id: 'lu-9485148810',
                safe: {
                    type: 'Numeric',
                    is_decimal_allowed: false,
                },
            },
        ],
    },
    'lb-109574533': {
        id: 'lb-109574533',
        name: 'Weight for Height (Z-Score)',
        dis_name: 'Weight for Height (Z-Score)',
        units_with_ranges: [
            {
                dis_unit: 'Score',
                code_id: 'lu-8580719618',
                safe: {
                    type: 'Numeric',
                    is_decimal_allowed: false,
                },
            },
        ],
    },
    // BMI
    'lb-2338475860': {
        id: 'lb-2338475860',
        name: 'BMI for Age (Percentile)',
        dis_name: 'BMI for Age (Percentile)',
        units_with_ranges: [
            {
                dis_unit: 'Percentile',
                code_id: 'lu-9485148810',
                safe: {
                    type: 'Numeric',
                    is_decimal_allowed: false,
                },
            },
        ],
    },
    'lb-2554319072': {
        id: 'lb-2554319072',
        name: 'BMI for Age (Z-Score)',
        dis_name: 'BMI for Age (Z-Score)',
        units_with_ranges: [
            {
                dis_unit: 'Score',
                code_id: 'lu-8580719618',
                safe: {
                    type: 'Numeric',
                    is_decimal_allowed: false,
                },
            },
        ],
    },
    // OFC
    'lb-1370917773': {
        id: 'lb-1370917773',
        name: 'OFC for Age (Precentile)',
        dis_name: 'OFC for Age (Precentile)',
        units_with_ranges: [
            {
                dis_unit: 'Percentile',
                code_id: 'lu-9485148810',
                safe: {
                    type: 'Numeric',
                    is_decimal_allowed: false,
                },
            },
        ],
    },
    'lb-9521575216': {
        id: 'lb-9521575216',
        name: 'OFC for Age (Z-Score)',
        dis_name: 'OFC for Age (Z-Score)',
        units_with_ranges: [
            {
                dis_unit: 'Score',
                code_id: 'lu-8580719618',
                safe: {
                    type: 'Numeric',
                    is_decimal_allowed: false,
                },
            },
        ],
    },
};

export const GROWTH_CHART_NAME_KEY_GROUP_MAPPING = [
    {
        name: GROWTH_CHART_NAME.WEIGHT_FOR_AGE,
        percentile: 'lb-6580967293',
        zIndexId: 'lb-1297034741',
    },
    {
        name: GROWTH_CHART_NAME.HEIGHT_FOR_AGE,
        percentile: 'lb-8961902374',
        zIndexId: 'lb-489488198',
    },
    {
        name: GROWTH_CHART_NAME.WEIGHT_FOR_HEIGHT,
        percentile: 'lb-953907228',
        zIndexId: 'lb-109574533',
    },
    {
        name: GROWTH_CHART_NAME.BMI_FOR_AGE,
        percentile: 'lb-2338475860',
        zIndexId: 'lb-2554319072',
    },
    {
        name: GROWTH_CHART_NAME.OFC_FOR_AGE,
        percentile: 'lb-1370917773',
        zIndexId: 'lb-9521575216',
    },
];

export const DEFAULT_MEDICAL_HISTORY_CONFIG_VALUES: MedicalHistoryConfig = {
    commonItems: [
        {
            id: 'd-9556844817',
            name: 'Diabetes mellitus',
            catId: MEDICAL_HISTORY_CATEGORY.PATIENT_MEDICAL_CONDITIONS,
        },
        {
            id: 'd-3975306476',
            name: 'Hypertension',
            catId: MEDICAL_HISTORY_CATEGORY.PATIENT_MEDICAL_CONDITIONS,
        },
        {
            id: 'd-4558712740',
            name: 'Hypothyroidism',
            catId: MEDICAL_HISTORY_CATEGORY.PATIENT_MEDICAL_CONDITIONS,
        },
        {
            id: '3',
            name: 'Alcohol',
            catId: MEDICAL_HISTORY_CATEGORY.LIFESTYLE_HABITS,
        },
        {
            id: '1',
            name: 'Tobacco',
            catId: MEDICAL_HISTORY_CATEGORY.LIFESTYLE_HABITS,
        },
        {
            id: '2',
            name: 'Smoke',
            catId: MEDICAL_HISTORY_CATEGORY.LIFESTYLE_HABITS,
        },
    ],
    sections: [
        {
            label: 'Existing Conditions',
            type: 'string',
            key: MEDICAL_HISTORY_CATEGORY.PATIENT_MEDICAL_CONDITIONS,
        },
        {
            label: 'Current Medications',
            type: 'string',
            key: MEDICAL_HISTORY_CATEGORY.CURRENT_MEDICATIONS,
        },
    ],
};

export const DEFAULT_SECTION_NAME_CONFIG_VALUES: SectionNameConfig = {};

export const DEFAULT_CONFIG_ELEMENT_IN_DOUBLE_COLUMNS = {
    left: ['symptoms', 'vitals'],
    right: ['diagnosis', 'labTests'],
};

export const IGNORE_CONFIG_KEYS = new Set(['sym-dia', 'prescribe', 'followup', 'advices']);

type DataVersion = {
    version?: number;
};

export type PtDirVersion = DataVersion;
export type GenieVersion = DataVersion;

export const DEFAULT_PT_DIR_VERSION = { version: 2 };
export const DEFAULT_GENIE_VERSION = { version: 4 };

export type PtDirLastUpdatedAt = {
    isoString?: string;
};

export type MilestoneUpdatedAt = {
    isoString?: string;
    version?: string;
};

export type ActiveOrderUpdatesLastUpdatedAt = {
    active_from?: number;
};

export type ActiveOrderUpdatesCount = {
    count?: number;
};

// export type FileSystemFileHandle = {
//     file: any; // FileSystemHandle;
// };
interface FileSystemCreateWritableOptions {
    keepExistingData?: boolean;
}

type FileSystemWritableFileStream = {
    write: (data: BufferSource | Blob | string) => Promise<void>;
    seek: (position: number) => Promise<void>;
    truncate: (size: number) => Promise<void>;
    close: () => Promise<void>;
};

export type FileSystemFileHandler = {
    kind: 'file';
    name: string;
    getFile(): Promise<File>;
    createWritable(
        options?: FileSystemCreateWritableOptions,
    ): Promise<FileSystemWritableFileStream>;
};

export type BackgroundConfig = {
    backgroundImage: {
        id: string;
        name: string;
        type: string;
        dataUrl: string;
    };
    lastSelectedTeleBg: {
        option: string;
    };
};

export type GenieLastUpdatedAt = PtDirLastUpdatedAt;

export const PT_DIR_LAST_UPDATED_AT: PtDirLastUpdatedAt = {
    isoString: undefined,
};

export const ACTIVE_ORDER_UPDATES_LAST_UPDATED_AT: ActiveOrderUpdatesLastUpdatedAt = {
    active_from: undefined,
};

export const ACTIVE_ORDER_UPDATES_COUNT: ActiveOrderUpdatesCount = {
    count: 0,
};

export const GINIE_LAST_UPDATED_AT: GenieLastUpdatedAt = {
    isoString: undefined,
};

export type LastSelctedBgOption = {
    option: string;
};

export const DEFAULT_TRANSLATE: Translate = { flag: false, lang: '' };

export type InterpretationEnum = {
    id: string;
    value: string;
    eka_id?: string;
    name_list?: string[];
};

export const INTERPOLATION_VALUES: InterpretationEnum[] = [
    {
        id: 'sm-1420480405',
        value: 'High',
        eka_id: 'sm-1420480405',
        name_list: ['High', 'Elevated'],
    },
    {
        id: 'sm-8146614980',
        value: 'Normal',
        eka_id: 'sm-8146614980',
        name_list: ['Normal', 'Unremarkable'],
    },
    {
        id: 'sm-1220479757',
        value: 'Low',
        eka_id: 'sm-1220479757',
        name_list: ['Low'],
    },
    {
        id: 'sm-4067205096',
        value: 'Critically high',
        eka_id: 'sm-4067205096',
        name_list: ['critically_high'],
    },
    {
        id: 'sm-5279215230',
        value: 'Borderline high',
        eka_id: 'sm-5279215230',
        name_list: ['borderline_high'],
    },
    {
        id: 'sm-2631712380',
        value: 'Very high',
        eka_id: 'sm-2631712380',
        name_list: ['very_high'],
    },
    {
        id: 'sm-5279274814',
        value: 'Borderline low',
        eka_id: 'sm-5279274814',
        name_list: ['borderline_low'],
    },
    {
        id: 'sm-2631771970',
        value: 'Very low',
        eka_id: 'sm-2631771970',
        name_list: ['very_low'],
    },
    {
        id: 'sm-4067860500',
        value: 'Critically low',
        eka_id: 'sm-4067860500',
        name_list: ['critically_low'],
    },
    {
        id: 'sm-5379306527',
        value: 'Abnormal',
        eka_id: 'sm-5379306527',
        name_list: ['abnormal'],
    },
];

export const INTERPOLATION_VALUES_FOR_PANELS: InterpretationEnum[] = [
    {
        id: 'sm-8146614980',
        value: 'Normal',
        eka_id: 'sm-8146614980',
        name_list: ['Normal', 'Unremarkable'],
    },
    {
        id: 'sm-5379306527',
        value: 'Abnormal',
        eka_id: 'sm-5379306527',
        name_list: ['abnormal'],
    },
];

export type StatusEnum = {
    id: string;
    value: string;
    label?: string;
};

export const STATUS_VALUES: StatusEnum[] = [
    {
        id: 'local-1024094343',
        value: 'Active',
        label: 'Yes (Active)',
    },
    {
        id: 'local-1024004346',
        value: 'Inactive',
        label: 'No (Inactive)',
    },
];

export const FAMILY_MEMBERS_NAME: StatusEnum[] = [
    {
        id: 'sm-6044310999',
        value: 'Husband',
    },
    {
        id: 'sm-6044966401',
        value: 'Wife',
    },
    {
        id: 'sm-1034094231',
        value: 'Father',
    },
    {
        id: 'sm-1034094232',
        value: 'Mother',
    },
    {
        id: 'sm-1034094233',
        value: 'Son',
    },
    {
        id: 'sm-1034094234',
        value: 'Daughter',
    },
    {
        id: 'sm-1034094235',
        value: 'Brother',
    },
    {
        id: 'sm-1034094236',
        value: 'Sister',
    },
    {
        id: 'sm-1034094237',
        value: 'Grandfather',
    },
    {
        id: 'sm-1034094238',
        value: 'Grandmother',
    },
    {
        id: 'sm-1034094239',
        value: 'Spouse',
    },
    {
        id: 'sm-6912834509',
        value: 'Father & Mother',
    },
    {
        id: 'sm-739868579',
        value: 'Cousin Brother',
    },
    {
        id: 'sm-8948775557',
        value: 'Cousin Sister',
    },
    {
        id: 'sm-9561104524',
        value: 'Paternal Uncle',
    },
    {
        id: 'sm-9901934348',
        value: 'Paternal Aunt',
    },
    {
        id: 'sm-1274041756',
        value: 'Maternal Uncle',
    },
    {
        id: 'sm-9901904556',
        value: 'Maternal Aunt',
    },
    {
        id: 'sm-1753007960',
        value: 'Paternal Grandfather',
    },
    {
        id: 'sm-1753067543',
        value: 'Paternal Grandmother',
    },
    {
        id: 'sm-1753037747',
        value: 'Maternal Grandfather',
    },
    {
        id: 'sm-1753097326',
        value: 'Maternal Grandmother',
    },
    {
        id: 'sm-1873723145',
        value: 'Great grandfather',
    },
    {
        id: 'sm-4112603700',
        value: 'Great grandmother',
    },
    {
        id: 'sm-486244136',
        value: 'Niece',
    },
    {
        id: 'sm-7159278787',
        value: 'Nephew',
    },
];

export const FAMILY_MEMBERS_ID_TO_NAME = FAMILY_MEMBERS_NAME.reduce((acc, { id, value }) => {
    acc[id] = value;
    return acc;
}, {} as { [k: string]: string });

export const doctorIds = [
    '161420040458433',
    '161467756044203',
    '161479131229772',
    '161562324381176',
    '161932674478535',
    '162029640452487',
    '162200734595503',
    '162650205052935',
    '162773715325734',
    '162969859985500',
    '163678392853165',
    '163895794888275',
    '164040473083283',
    '164205062632124',
    '164605676834206',
    '164663763791647',
    '164733883524158',
    '164975848973713',
    '165304988440871',
    '165355659363438',
    '165449938139833',
    '165554223029861',
    '165631910583983',
    '165675351065908',
    '165813088249102',
    '166062534924722',
    '166063449093185',
    '166134459213661',
    '166219599792811',
    '166305505526605',
    '166315780123110',
    '166377160131608',
    '166385038887771',
    '166479907802581',
    '166504126755436',
    '166521760915684',
    '166624759967735',
    '166806285710143',
    '166816892454644',
    '166848982566445',
    '166996972144344',
    '167004360023147',
    '167005116006302',
    '167119772268531',
    '167151758392177',
];

export const start_from: { value: number; unit: 'months' }[] = [
    {
        value: 3,
        unit: 'months',
    },
    {
        value: 6,
        unit: 'months',
    },
    {
        value: 12,
        unit: 'months',
    },
];

export const expires_in: { value: number; unit: 'month' | 'months' | 'week' }[] = [
    {
        value: 1,
        unit: 'week',
    },
    {
        value: 1,
        unit: 'month',
    },
    {
        value: 3,
        unit: 'months',
    },
    {
        value: 6,
        unit: 'months',
    },
    {
        value: 12,
        unit: 'months',
    },
];

export const record_types = [
    'OPConsultation',
    'Prescription',
    'DischargeSummary',
    'DiagnosticReport',
    'ImmunizationRecord',
    'HealthDocumentRecord',
    'WellnessRecord',
];

export const purpose_types = [
    {
        value: 'Care management',
        label: 'Care management',
    },
    {
        value: 'Public Health',
        label: 'Public Health',
    },
    {
        value: 'Disease Specific Health Research',
        label: 'Disease Specific Health Research',
    },
];

export const FIXED_QUANTITIES = {
    'df-7435419319': '1 unit',
    'df-6923115097': '1 bottle',
    'df-769375585': '1 bottle',
    'df-5140156421': '1 bottle',
    'df-6760636010': '1 inhaler',
    'df-4787871768': '1 bottle',
    'df-6941042110': '1 unit',
    'df-3472438845': '1 unit',
    'df-4608470948': '1 bottle',
    'df-4120857860': '1 bottle',
    'df-5880427153': '1 unit',
    'df-6938132552': '1 bottle',
    'df-9603977956': '1 unit',
    'df-2069779518': '1 unit',
    'df-150499117': '1 bottle',
    'df-3972100204': '1 unit',
    'df-7737387403': '1 unit',
    'df-3667869230': '1 unit',
    'df-6169979882': '1 bottle',
    'df-6922544981': '1 unit',
    'df-6633941317': '1 bottle',
    'df-6712141710': '1 bottle',
    'df-1398356916': '1 bottle',
    'df-1975273371': '1 bottle',
    'df-9001195403': '1 bottle',
    'df-6639735669': '1 unit',
    'df-5596594528': '1 bottle',
    'df-2859918947': '1 bottle',
    'df-694631431': '1 sachet',
    'df-9785838630': '1 unit',
    'df-8590746745': '1 unit',
    'df-1728325352': '1 unit',
    'df-2506911363': '1 unit',
    'df-2912401248': '1 unit',
    'df-9961081561': '1 bottle',
    'df-1451863148': '1 bottle',
    'df-797376788': '1 unit',
    'df-374189216': '1 bottle',
    'df-805057610': '1 bottle',
    'df-4924674628': '1 unit',
    'df-6602885500': '1 unit',
    'df-7836556548': '1 unit',
    'df-1402596922': '1 bottle',
    'df-2445311184': '1 unit',
    'df-9993424923': '1 bottle',
    'df-1974770544': '1 bottle',
    'df-8608641828': '1 unit',
    'df-9668524941': '1 unit',
    'df-2185195660': '1 unit',
    'df-1970465927': '1 unit',
    'df-3441448086': '1 bottle',
    'df-4857666393': '1 unit',
    'df-4147196478': '1 unit',
    'df-4780496579': '1 bottle',
    'df-5459446376': '1 unit',
    'df-8612103017': '1 unit',
    'df-8814284469': '1 unit',
    'df-733458396': '1 unit',
    'df-6628063675': '1 bottle',
    'df-1413258956': '1 unit',
    'df-7062944040': '1 unit',
    'df-6899457170': '1 unit',
    'df-488828760': '1 bottle',
    'df-49277547': '1 bottle',
    'df-4610327408': '1 bottle',
    'df-2510839905': '1 bar',
    'df-4579193229': '1 strip',
    'df-6242474875': '1 unit',
    'df-8139584503': '1 unit',
    'df-6464983615': '1 unit',
    'df-2301953601': '1 unit',
    'df-8740451759': '1 unit',
    'df-8561854012': '1 bottle',
    'df-9502229030': '1 bottle',
    'df-8141538667': '1 bottle',
    'df-892432463': '1 bottle',
    'df-5940101371': '1 bottle',
    'df-8820373639': '1 unit',
    'df-8668057458': '1 unit',
    'df-4482240240': '1 unit',
    'df-8035473675': '1 unit',
    'df-5915986529': '1 unit',
    'df-9712763045': '1 bottle',
    'df-7602769613': '1 inhaler',
    'df-5009101888': '1 unit',
    'df-6963584685': '1 unit',
    'df-3938940522': '1 unit',
    'df-2952738396': '1 bottle',
    'df-1555529487': '1 bottle',
    'df-2301559214': '1 unit',
    'df-8954941358': '1 unit',
    'df-3624276106': '1 unit',
    'df-964807772': '1 unit',
    'df-7062102740': '1 unit',
    'df-6971888151': '1 bottle',
    'df-4975687547': '1 unit',
    'df-3659458418': '1 bottle',
    'df-9098309878': '1 bottle',
    'df-350518404': '1 unit',
    'df-1661594237': '1 bottle',
    'df-5832289277': '1 bottle',
    'df-7785667552': '1 bottle',
    'df-8689239835': '1 unit',
    'df-9322074283': '1 unit',
    'df-9055674334': '1 bottle',
    'df-2742055965': '1 unit',
    'df-6409891484': '1 unit',
    'df-9556291415': '1 unit',
    'df-5202483433': '1 unit',
    'df-6559745513': '1 unit',
    'df-9276666923': '1 unit',
    'df-3888208290': '1 bottle',
    'df-9272193856': '1 unit',
    'df-8601875703': '1 bottle',
    'df-8771066655': '1 unit',
    'df-9814665346': '1 bottle',
    'df-4627026063': '1 bottle',
    'df-7230132448': '1 unit',
    'df-3579023307': '1 unit',
    'df-4289419884': '1 vial',
    'df-6442824734': '1 unit',
    'df-3660142317': '1 unit',
    'df-2103416312': '1 unit',
    'df-7831496676': '1 unit',
    'df-1846920497': '1 unit',
    'df-3529236065': '1 unit',
    'df-4479311395': '1 unit',
    'df-3474766597': '1 unit',
    'df-1032348': '1 unit',
};

export const TOOL_PLAN_PERSUASION_ID = 'tool_plan_payment_persuasion';

export const HIV_CONSENT_LAB_TESTS = new Set([
    'lb-9643925132',
    'lb-956255647',
    'lb-879533033',
    'lb-4409573140',
    'lb-9911715359',
    'lb-9138241262',
    'lb-6714251736',
    'lb-879533033',
    'lb-7111310936',
    'lb-6874833597',
    'lb-5905310947',
    'lb-5929759255',
    'lb-9431481322',
    'lb-69014312',

    //
    'lp-1136486706',
    'lb-956255647',
    'lp-789834330',
    'lp-1136486706',
]);

export const WHITELISTED_EDIT_SECTION_NAME_KEYS = [
    'symptoms',
    'diagnosis',
    'sym-dia',
    'medications',
    'labTests',
    'labVitals',
    'prescribe',
    'refer',
    'prescriptionNotes',
    'examinations',
    'followup-advices',
];

export const BLACK_LISTED_COUNTRIES = new Set([
    'AG',
    'AI',
    'AS',
    'GD',
    'GU',
    'KN',
    'LC',
    'MS',
    'SX',
    'VC',
    'VG',
    'VI',
    'DO',
    'BS',
    'KY',
    'MP',
    'TC',
    'UM',
    'BB',
    'BM',
]);

export const PRIORITY_COUNTRIES = ['IN', 'US', 'BD', 'SG', 'MY', 'AE'];

export const injectionRowHeaderMapping: Record<INJECTION_COLUMN, string> = {
    [INJECTION_COLUMN.DRUG]: 'Generic',
    [INJECTION_COLUMN.DOSE]: 'eg. 1 ml',
    [INJECTION_COLUMN.ROUTE]: 'eg. IV, SC',
    [INJECTION_COLUMN.INFUSION_RATE]: 'eg. 7 ml/hr, etc',
    [INJECTION_COLUMN.FREQUENCY]: 'eg. 1-0-1 etc',
    [INJECTION_COLUMN.TIMING]: 'eg. after meal',
    [INJECTION_COLUMN.DURATION]: 'eg. 3 days',
    [INJECTION_COLUMN.INSTRUCTIONS]: 'if any...',
};

export const ekaScribeExtensionDownloadURL =
    'https://chromewebstore.google.com/detail/ekascribe/nncfcjgelepkhpjfkejgkncdfbcfmhom?hl=en';

export enum GenieTableType {
    MED = 'medications',
    INJ = 'injections',
    LAB = 'lab_investigations',
    CUS = 'custom_sections',
}

export const PAD_ELEMENTS_IDS: string[] = [
    ...DEFAULT_PAD_CONFIG.map((ele) => ele.id),
    ...IGNORE_CONFIG_KEYS,
];
